
// class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super();

//     this.input = this.querySelector('input[type="search"]');
//     this.predictiveSearchResults = this.querySelector('#predictive-search');
//     this.input.addEventListener('input', this.debounce((event) => {
//       this.onChange(event);
//     }, 300).bind(this));
//   }

//   onChange() {
//     const searchTerm = this.input.value.trim();
//     if (!searchTerm.length) {
//       this.close();
//       return;
//     }

//     this.getSearchResults(searchTerm);
//   }

//   getSearchResults(searchTerm) {
    
//     fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           this.close();
//           throw error;
//         }
//         return response.text();
//       })
//       .then((text) => {
//         const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
//         this.predictiveSearchResults.innerHTML = resultsMarkup;
//         this.open();
//       })
//       .catch((error) => {
//         this.close();
//         throw error;
//       });
//   }

//   open() {
//     this.predictiveSearchResults.style.display = 'block';
//   }

//   close() {
//     this.predictiveSearchResults.style.display = 'none';
//   }

//   debounce(fn, wait) {
//     let t;
//     return (...args) => {
//       clearTimeout(t);
//       t = setTimeout(() => fn.apply(this, args), wait);
//     };
//   }

// }
  

// customElements.define('predictive-search', PredictiveSearch);

// /* Drop Down Box Out Side Click then clise the Dropdown Box Code  */

//   let searchBar = document.querySelector(".header__search-bar-wrapper");
//  window.addEventListener("click", function(event){
//  if(!searchBar.contains(event.target)){
//     let hideForm = document.getElementById("predictive-search");
//      hideForm.style.display="none"
//      }
//      else
//      {
//     hideForm.style.display="block"
//      }
//  });
//  console.log(searchBar);


     

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    // Select necessary elements
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = document.getElementById('predictive-search');

    // Bind event listener
    this.input.addEventListener('input', this.debounce(this.onChange.bind(this), 300));

    // Click event listener to close predictive search results when clicking outside
    window.addEventListener("click", (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });
  }

  onChange(event) {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&*+tag:${searchTerm}&type=product,collection&resources[options][fields]=title,tag,variants.sku`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((text) => {
        console.log('Search Results HTML:', text); // Log the fetched HTML
        this.predictiveSearchResults.innerHTML = text;
        this.open();
      })
      .catch((error) => {
        console.error('Fetch error:', error);
        this.close();
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        fn.apply(this, args);
      }, wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
